import React from 'react'
import PropTypes from 'prop-types'

import { Alert } from 'loyal-react'
import SearchPlaceHolder from 'Catalog/Search/SearchPlaceHolder'
import SidebarPlaceholder from 'Catalog/Search/SidebarPlaceholder'

const bgBanner = {
  backgroundColor: '#D2DCDE'
}

const showError = error =>
  error ? (
    <Alert
      isError
      title={error.title}
      description={error.description}
      className='pb-2'
      onClose={() => error.closeError()}
    />
  ) : (
    ''
  )

const Redirect = ({ errorAlert }) => (
  <div>
    {showError(errorAlert)}
    <div className='container-fluid container-results mb-3'>
      <div className='row'>
        <div className='col-12 px-0'>
          <div className='row py-2 innerShadow' style={bgBanner}>
            <div className='col-12 px-0 py-5' />
          </div>
          <div className='row bg-transparent'>
            <div className='container  pos-relative py-1 px-2'>
              <div className='row pos-relative'>
                <div className='thumbStore col-auto d-none d-md-flex py-half px-half border border-color-ui-3 bg-white'>
                  <div className='row  align-items-center h-100'>
                    <div className='col' />
                  </div>
                </div>
                <div className='offset-0 offset-md-2 col-12 col-md pos-relative' />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className='container mt-5 mt-md-0 pt-5 pt-md-0'>
      <div className='row'>
        <SidebarPlaceholder />
        <SearchPlaceHolder />
      </div>
    </div>
  </div>
)

Redirect.propTypes = {
  errorAlert: PropTypes.object
}

export default Redirect



// WEBPACK FOOTER //
// ./src/features/Redirect/Redirect.js